import { formatIncompletePhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';

const normalizeDigits = (value: string) => {
    return value.replace(/\D/g, '');
};

export const normalizePhoneNumberInput = (value?: string) => {
    if (!value) {
        return '';
    }

    const digits = normalizeDigits(value);

    return digits ? `+${digits}` : '';
};

export const formatPhoneNumber = (value?: string) => {
    if (!value) {
        return '';
    }

    const digits = normalizeDigits(value);

    if (!digits) {
        return '';
    }

    const phoneNumber = parsePhoneNumberFromString(`+${digits}`);

    if (!phoneNumber) {
        return '';
    }

    return phoneNumber.formatInternational();
};

export const formatPhoneNumberInput = (value?: string) => {
    const normalizedValue = normalizePhoneNumberInput(value);

    if (!normalizedValue) {
        return '';
    }

    const phoneNumber = parsePhoneNumberFromString(normalizedValue);

    if (phoneNumber?.isValid()) {
        return formatPhoneNumber(normalizedValue);
    }

    return formatIncompletePhoneNumber(normalizedValue);
};
